/**
 * Extras Filter, used for filtering extras for display and extra categories
 */
bookingApp.filter('extrasFilter',['$filter',function(){
    var extrasFilter = function(input, checkPricing, categoryId, start, end, quantity, extras, extraPrices, isItemOnly){
        var out = [];
        angular.forEach(input, function(extra){
            // should be shown
            if(typeof isItemOnly !== 'undefined' && isItemOnly){
                if(extra.allowExtrasOnlyBookings){
                    //var price = checkPricing(categoryId, extra.id, start, end, quantity, extras, extraPrices);
                    //if (!(price === null || price.priceFrom === null)) {
                    //    var momStart = moment(start);
                    //    var momEnd = moment(end);
                    //    var daysDiff = moment.duration(momEnd.diff(momStart)).asDays();
                    //    if ((extra.maxPeriods === null) || (extra.maxPeriods >= daysDiff)) {
                    //        out.push(extra);
                    //    }
                    //}
                    out.push(extra);
                }
            }else {
                if (extra.allowFrontEndBookings) {
                    var price = checkPricing(categoryId, extra.id, start, end, quantity, extras, extraPrices);
                    if (!(price === null || price.priceFrom === null)) {
                        var momStart = moment(start);
                        var momEnd = moment(end);
                        var daysDiff = moment.duration(momEnd.diff(momStart)).asDays();
                        if ((extra.maxPeriods === null) || (extra.maxPeriods >= daysDiff)) {
                            out.push(extra);
                        }
                    }
                }
                else {
                    // check if we should show unavailable, if so still return the extra
                    if(extra.showUnavailable){
                        out.push(extra);
                    }
                }
            }
        });
        //return out;
        var finalOut = [];
        angular.forEach(out, function(extra){
            if(isItemOnly){
                if(extra.capturePaxDetails){
                    finalOut.push(extra);
                }
            } else {
                finalOut.push(extra);
            }
        });
        return finalOut;
    };
    return extrasFilter;
}]);